import * as React from 'react';
import {
    createSaveSearchKeyBySearchParams,
    deleteSavedSearch,
    getIsSavedSearch,
    submitSaveSearch,
} from '@/redux/modules/saveSearch';
import { FormattedMessage } from '@liveauctioneers/hammer-ui-core/intl';
import { GlobalState } from '@/redux/store';
import { SearchParams as SearchParamsType } from '@/types/SaveSearch';
import { useAppDispatch, useAppSelector } from '@/redux/hooks';
import SaveSearch from './SaveSearch';

type Props = {
    allSearchParams?: SearchParamsType;
    className?: string;
    saveSearchParams: SearchParamsType;
    small?: boolean;
    tooltipPlacement?: React.ComponentProps<typeof SaveSearch>['tooltipPlacement'];
};

const SaveSearchContainer = ({ allSearchParams, className, saveSearchParams, small, tooltipPlacement }: Props) => {
    const dispatch = useAppDispatch();

    const savedSearchKey = createSaveSearchKeyBySearchParams(saveSearchParams);
    const isSavedSearch = useAppSelector((state: GlobalState) => getIsSavedSearch(state, savedSearchKey));

    const submitSaveSearchLocal = React.useCallback(() => {
        dispatch(submitSaveSearch(saveSearchParams, true));
    }, [dispatch, saveSearchParams]);

    const deleteSavedSearchLocal = React.useCallback(() => {
        if (isSavedSearch) {
            dispatch(deleteSavedSearch(saveSearchParams));
        }
    }, [dispatch, isSavedSearch, saveSearchParams]);

    return (
        <SaveSearch
            allSearchParams={allSearchParams}
            className={className}
            deleteSavedSearch={deleteSavedSearchLocal}
            isSavedSearch={isSavedSearch}
            small={small}
            submitSaveSearch={submitSaveSearchLocal}
            tooltipMessage={
                <FormattedMessage
                    id="follow_search_tooltip"
                    values={{ br: <br key="br" /> }}
                />
            }
            tooltipPlacement={tooltipPlacement}
        />
    );
};

export default SaveSearchContainer;
